module.exports = require("./vai-Latn.js");